import React, { useState } from 'react';
import Select, { SelectProps } from 'antd/lib/select';
import { useQuery } from 'react-query';

import {
  getUsersListByDepartment,
  GetUsersListByDepartmentParams,
} from 'services/parametersService';
import { isNil } from 'lodash';

export type UsersProps = SelectProps<any> & {
  parentValue: string;
};

const UsersInputByDepartment = (props: UsersProps) => {
  const { parentValue } = props;
  const [searchParams] = useState<GetUsersListByDepartmentParams>({
    parentValue: parentValue ?? 'RECO',
  });

  const { data } = useQuery(
    ['getUsersListByDepartment', searchParams],
    () => getUsersListByDepartment(searchParams).then((res) => res.list ?? []),
    { enabled: !isNil(parentValue) }
  );

  return (
    <Select allowClear {...props}>
      {data?.map((user, index) => {
        return (
          <Select.Option value={user.userid} key={index}>
            {user.username}
          </Select.Option>
        );
      })}
    </Select>
  );
};

export default UsersInputByDepartment;
